var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOmtoLogoBack = function SvgOmtoLogoBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91,
    height: 85,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M41.93.63C19.57 2.35 1.64 20.61.3 43c-.41 6.8.69 13.29 3 19.19.28.73 1.23.91 1.79.36L19 48.64c.23-.23.34-.54.31-.86-.04-.5-.07-1.01-.08-1.52C19 33.73 27.4 22.81 39.65 20.15c17.03-3.69 32.12 9.24 32.12 25.64 0 .36 0 .73-.02 1.09-.01.31.09.61.31.83l14.12 14.12c.56.56 1.52.37 1.79-.37 1.81-4.88 2.8-10.16 2.8-15.67C90.77 19.63 68.48-1.4 41.91.64z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3484F7",
    d: "M82.18 69.85c.58.58.67 1.5.2 2.17a44 44 0 0 1-4.01 4.85c-1.12 1.2-2.31 2.33-3.58 3.4a42 42 0 0 1-4.07 3.08c-.67.45-1.56.34-2.13-.23L49 63.53a4.255 4.255 0 0 0-6 0L23.01 83.52c-.56.56-1.45.67-2.11.24a44 44 0 0 1-4.14-3.05 43.5 43.5 0 0 1-4.67-4.44c-1.08-1.17-2.09-2.4-3.03-3.68-.49-.67-.41-1.6.18-2.19l12.82-12.83 7.5-7.5c9.07-9.06 23.81-9.06 32.88 0l19.75 19.75z"
  })));
};
export default SvgOmtoLogoBack;